import { ApiUtility } from "../Utilities/ApiUtility.axios";

// Don't name the class the same as the file's export
class DailyPracticeStatsService {
    route = `/Api/DailyPracticeStats`;

    //getDailyPracticeStats = (params) => {
    //    // Construct a URLSearchParams object from the params object
    //    const queryParams = new URLSearchParams(params).toString();

    //    // Append the query string to the URL
    //    // The ternary operator ensures no '?' is added if there are no parameters
    //    return ApiUtility.get(`${this.route}/getpracticestats${queryParams ? `?${queryParams}` : ''}`);
    //};
  getDailyPracticeStats = ({
    start = 0,
    length = 15,
    search = "",
    practiceId = "",
    fromDate = "",
    toDate = "",
    sortCol = "",
    sortDir = "",
  }: {
    start?: number;
    length?: number;
    search?: string;
    practiceId?: string | number;
    fromDate?: string;
    toDate?: string;
    sortCol?: string;
    sortDir?: string;
  } = {}) => {
    let url = `${this.route}/getpracticestats?start=${start}&length=${length}&search=${encodeURIComponent(search)}&fromDate=${fromDate}&toDate=${toDate}&sortCol=${sortCol}&sortDir=${sortDir}`;
    if (practiceId) {
      url += `&practiceId=${practiceId}`;
    }
    return ApiUtility.get(url);
  };


  downloadPracticePdf = async (practiceId: number, fromDate?: string, toDate?: string) => {
    return ApiUtility.downloadFile(`${this.route}/${practiceId}/DownloadPdf`, {
      fromDate,
      toDate,
      _t: Date.now(),
    });
  };
}

// Export an instance
export default new DailyPracticeStatsService();
